import { inject } from "aurelia-framework";
import { LocaleService } from "../services/locale-service";

@inject(LocaleService)
export class BooleanValueConverter {
  constructor(private localeService: LocaleService) {}

  toView(value: boolean): string {
    return this.localeService.getTrueOrFalse(value);
  }
}
